import { atom } from 'jotai';

export interface LocationGroupFormState {
  name: string;
  facilityIds: string[];
  defaultFacilityId?: string;
}

const initialState: LocationGroupFormState = {
  name: '',
  facilityIds: [],
  defaultFacilityId: undefined,
};

export const $locationGroupForm = atom<LocationGroupFormState>(initialState);

export const $updateLocationGroupForm = atom(
  null,
  (get, set, update: Partial<LocationGroupFormState>) => {
    const currentState = get($locationGroupForm);
    set($locationGroupForm, {
      ...currentState,
      ...update,
    });
  },
);

export const $resetLocationGroupForm = atom(null, (get, set) => {
  set($locationGroupForm, initialState);
});
